<template>
  <div class="messageNotify-item" data-type="0">
    <div class="messageNotify-itemLeft" @touchstart.capture="touchStart" @touchend.capture="touchEnd" @click="skip(value,index)">
      <div>
        <img v-if="value.FeatureCodes.indexOf('system')>-1" src="/static/img/系统消息.png" style="width:1.197rem;vertical-align: middle;" />
        <img v-if="value.FeatureCodes.indexOf('remind')>-1" src="/static/img/消息通知.png" style="width:1.197rem;vertical-align: middle;" />
      </div>
      <div class="messageNotify-text">
        <div>
          <span v-if="value.FeatureCodes.indexOf('system')>-1">{{$t('system_messagenotify_notifyitem_xitongtongzhi')}}</span>
          <span v-if="value.FeatureCodes.indexOf('remind')>-1">{{$t('system_messagenotify_notifyitem_xiaoxitixing')}}</span>
          <span>{{$t('system_messagenotify_notifyitem_ganggang')}}</span>
        </div>
        <div class="ellipsis" style="padding-right:0.930rem;height:0.532rem;line-height: 0.532rem;position: relative;">
          <span>{{value.NotifyTitle}}</span>
          <span class="messageNotify-newBtn" v-if="isReader(value)"></span>
        </div>
        <div class="border_bottom" style="margin-top:0.532rem;margin-left: 1.861rem"></div>
      </div>
    </div>
    <div class="messageNotify-delect" @click="messageNotifyDelect">{{$t('system_messagenotify_notifyitem_shanchu')}}</div>
  </div>
</template>
<style scoped>
  .messageNotify-item {
    position: relative;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
  }

  .messageNotify-itemLeft {
    height: 2.261rem;
  }

  .messageNotify-item[data-type="0"] {
    transform: translate3d(0, 0, 0);
    transition-duration: 0.2s;
  }

  .messageNotify-item[data-type="1"] {
    transform: translate3d(-1.861rem, 0, 0);
    transition-duration: 0.2s;
  }

  .messageNotify-itemLeft>div:first-child {
    width: 1.861rem;
    text-align: center;
    float: left;
    font-size: 0;
    height: 2.261rem;
    line-height: 2.261rem;
  }

  .messageNotify-text {
    height: 2.261rem;
    font-size: 0.345rem;
    color: #999;
  }

  .messageNotify-text>div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.133rem;
    height: 0.532rem;
    padding-right: 0.399rem;
    padding-top: 0.399rem;
  }

  .messageNotify-text>div:first-child>span:first-child {
    font-size: 0.425rem;
    color: #333;
  }

  .messageNotify-newBtn {
    display: block;
    background-color: red;
    width: 0.266rem;
    height: 0.266rem;
    border-radius: 50%;
    position: absolute;
    right: 0.399rem;
    z-index: 1;
    top: 50%;
    margin-top: -0.133rem;
  }

  .messageNotify-delect {
    width: 1.861rem;
    height: 1.861rem;
    line-height: 1.861rem;
    position: absolute;
    right: -1.861rem;
    top: 0;
    color: #fff;
    background-color: red;
    text-align: center;
  }

</style>
<script>
  export default {
    data() {
      return {
        startX: 0,
        endX: 0,
      }
    },
    props: ['value', 'index', 'UnreadIDs'],
    computed: {
      NotifyContentTypeTypes() {
        return this.$store.getters.categorys.types.NotifyContentType
      },

    },
    methods: {
      isReader(value) {
        let __self = this;
        let Flag = false
        if (__self.UnreadIDs) {
          let result = _.find(__self.UnreadIDs, function (o) {
            return o == value.NotifyID
          })
          if (result) {
            Flag = true
          } else {
            Flag = false
          }
        }
        return Flag
      },
      skip(value, index) {
        let __self = this;
        if (__self.checkSlide()) {
          __self.restSlide();
        } else {
          if (value.NotifyType == __self.NotifyContentTypeTypes.Html) {
            window.open(`/system/notify?NotifyID=${value.NotifyID}`);
          } else if (value.NotifyType == __self.NotifyContentTypeTypes.Link) {
            window.open(value.NotifyContent);
          }
          __self.$emit('skip', index, value.NotifyID)
          //   __self.UnreadIDs.splice(index, 1)
          //   $utils.localStorage.UnreadIDs = JSON.stringify(__self.UnreadIDs);
        }
      },
      touchStart(e) {
        let __self = this;
        __self.startX = e.touches[0].clientX;
      },
      touchEnd(e) {
        let __self = this;
        let parentElement = e.currentTarget.parentElement;
        __self.endX = e.changedTouches[0].clientX;
        if (parentElement.dataset.type == 0 && __self.startX - __self.endX > 30) {
          __self.restSlide();
          parentElement.dataset.type = 1;
        }
        if (parentElement.dataset.type == 1 && __self.startX - __self.endX < -30) {
          __self.restSlide();
          parentElement.dataset.type = 0;
        }
        __self.startX = 0;
        __self.endX = 0;
      },
      checkSlide() {
        let listItems = document.querySelectorAll('.messageNotify-item');
        for (let i = 0; i < listItems.length; i++) {
          if (listItems[i].dataset.type == 1) {
            return true;
          }
        }
        return false;
      },
      restSlide() {
        let listItems = document.querySelectorAll('.messageNotify-item');
        for (let i = 0; i < listItems.length; i++) {
          listItems[i].dataset.type = 0;
        }
      },
      messageNotifyDelect() {
        let __self = this;
        __self.restSlide();
        __self.$emit('deletes')
      },

    },

  }

</script>
